import React from "react";
import "./Footer.css";

function Footer({ onCancelClick }) {
  return (
    <div className="footer">
      Vodafone Global Enterprise Limited. Registered office: Vodafone House, The Connection, Newbury, Berkshire, RG14 2FN. Registered in England and Wales No 2844851
    </div>
  );
}

export default React.memo(Footer);
